import React, {useState, useRef} from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster
} from '@coreui/react';

const ImageModal = ({visible, setVisibleImageModal, addToast,image}) => {
  const exampleToast = (
    <CToast>
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <div className="fw-bold me-auto">CoreUI for React.js</div>
        <small>7 min ago</small>
      </CToastHeader>
      <CToastBody>Hello, world! This is a toast message.</CToastBody>
    </CToast>
  )
  const closeModal = () => {
    setVisibleImageModal(false)
  }
  const deleteFn = () => {
    addToast(exampleToast)
    setVisibleImageModal(false)
  }
  return (

    <div>
      <CModal alignment="center" visible={visible} onClose={() => {
        closeModal()
      }}>
        <CModalHeader onClose={() => closeModal()}>
          {/* <CModalTitle>Confirmation Modal</CModalTitle> */}
        </CModalHeader>
        <CModalBody>
          {
            image?<img src={image} width="100%"/>:"No Image to Show"
          }
          
          </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => closeModal()}>
            Close
          </CButton>
          {/* <CButton color="danger" onClick={() => onConfirm("confirm")}>
            Confirm
          </CButton> */}
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default ImageModal;
